import "./style.scss"
export const LoaderContainer = () => {
    return (
        <div className="loader-container">
            <div className="lds-ripple"><div></div><div></div></div>
        </div>
    )
}
